var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCamera = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "auto",
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.7007 9.36255H6.83841C5.27975 9.36255 4 10.6423 4 12.201V21.7826C4 23.3577 5.27975 24.6211 6.83841 24.6375H18.7007C20.2757 24.6375 21.5391 23.3577 21.5391 21.7991V12.201C21.5555 10.6423 20.2922 9.36255 18.7171 9.36255H18.7007Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8836 10.9327C27.7195 10.9655 27.5555 11.0311 27.4078 11.1295L23.4537 13.4101C23.1584 13.5742 22.9779 13.8859 22.9779 14.2305V19.7268C22.9779 20.0714 23.1584 20.3831 23.4537 20.5472L27.4406 22.8277C28.2446 23.3035 29.2782 23.041 29.754 22.2371C29.754 22.2207 29.7704 22.2207 29.7704 22.2043C29.9181 21.9418 30.0001 21.6464 30.0001 21.3511V12.5734C29.9837 11.6218 29.2126 10.867 28.2774 10.8834C28.1297 10.8834 28.0149 10.8998 27.8836 10.9327Z",
    fill: "currentColor"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCamera);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/camera.d2a3b01ee142f99f3fba2e15518a16a1.svg";